import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputDateUI from '../../../widgets/form/InputDateUI'

const LoanClosedDateUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  updateMode, submitted,
  onSubmit, onCancelClick,
  closedDate, onClosedDateChange, closedDateError, setClosedDateError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Set closed date'
    buttonLabel='Set'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputDateUI context={context} name='closedDate' label='Closed Date'
      selectedDateISO={closedDate} onChange={onClosedDateChange}
      error={closedDateError} setError={setClosedDateError}
      required={true}
    />
  </ModalFormUI>

export default LoanClosedDateUpdateModalUI
